import http from "../axios/index";
// 系统列表页面接口
export function getSubpage(params) {
  return http.request({
    method: "post",
    url: "/system/select",
    params
  });
}
// 新增接口
export function newlyAdded(data) {
  return http.request({
    method: "post",
    url: "/system/create",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data
  });
}
// 编辑接口
export function edit(data) {
  return http.request({
    method: "post",
    url: "/system/update",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data
  });
}
// 删除接口
export function cutOut(data) {
  return http.request({
    method: "post",
    url: "/system/delete",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data
  });
}

//频段列表
export function getDict(data) {
  return http.request({
    method: "post",
    url: "/dict/getDict",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data
  });
}



//根据设备类型获取设备特殊属性接口
export function devAttrByType(data) {
  return http.request({
    method: "post",
    url: "/device/devAttrByType",
    data
  });
}

//设备管理页面列表
export function equiList(data) {
  return http.request({
    method: "post",
    url: "/device/select",
    data
  });
}

//设备类型(信道机，合路平台)
export function machine(data) {
  return http.request ({
    method: "post",
    url: "/dict/getDict",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//系统频段
export function frequency(data) {
  return http.request ({
    method: "post",
    url: "/system/getNameAndCode",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//新增设备
export function newEquip(data) {
  return http.request ({
    method: "post",
    url: "/device/addDevice",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//获取设备详情
export function getDeviceById(data) {
  return http.request ({
    method: "post",
    url: "/device/getDeviceById",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//编辑设备
export function updateDeviceById(data) {
  return http.request ({
    method: "post",
    url: "/device/updateDeviceById",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//参数/告警设置
export function paramlist(data) {
  return http.request ({
    method: "post",
    url: "/device/paramlist",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//修改参数、告警
export function updateParam(data) {
  return http.request ({
    method: "post",
    url: "device/updateParam",
    headers: { "Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//一键导入
export function uploadFile(data) {
  return http.request ({
    method: "post",
    url: "/device/uploadFile",
    data
  })
}

//下载模板
export function download(data) {
  return http.request ({
    method: "get",
    url: "device/download",
    responseType: 'blob',
    data
  })
}

//分配系统
export function distributSysCode(data) {
  return http.request ({  
    method: "post",
    url: "/device/distributSysCode",
    headers: {"Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//删除系统
export function delSystem(data) {
  return http.request ({
    method: "post",
    url: "/device/delete",
    headers: {"Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//搜索数据
export function getDeviceByName(data) {
  return http.request ({
    method: "post",
    url: "/device/getDeviceByName",
    headers: {"Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//型号选择
export function getModelByDevType(data) {
  return http.request ({
    method: "post",
    url: "/device/getModelByDevType",
    data
  })
}



// -------------------告警列表----------------------------

//获取告警列表
export function getAlarmList(data) {
  return http.request ({
    method: "post",
    url: "alarm/select",
    headers: {"Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//获取告警数据统计
export function getAlarmCount(data) {
  return http.request ({
    method: "post",
    url: "alarm/alarmTimes",
    headers: {"Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//获取告警信息详情
export function getDeviceAlarm(data) {
  return http.request ({
    method: "post",
    url: "alarm/deviceAlarm",
    headers: {"Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//编辑告警信息
export function updateDeviceAlarm(data) {
  return http.request ({
    method: "post",
    url: "alarm/updateDeviceAlarm",
    headers: {"Content-Type": "application/json;charset=UTF-8" },
    data
  })
}



// -------------------服务配置----------------------------

//获取驱动list列表
export function getDriveList(data) {
  return http.request ({
    method: "post",
    url: "drive/list",
    headers: {"Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//驱动上传解压
export function driveUpload(data) {
  return http.request ({
    method: "post",
    url: "drive/upload",
    headers: {"Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//启动驱动
export function driveStart(data) {
  return http.request ({
    method: "post",
    url: "drive/start",
    headers: {"Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//停止驱动
export function driveStop(data) {
  return http.request ({
    method: "post",
    url: "drive/stop",
    headers: {"Content-Type": "application/json;charset=UTF-8" },
    data
  })
}

//重启驱动
export function driveRestart(data) {
  return http.request ({
    method: "post",
    url: "drive/restart",
    headers: {"Content-Type": "application/json;charset=UTF-8" },
    data
  })
}





// -------------------同步设置----------------------------

//获取驱动库列表
export function getDrivers(data) {
  return http.request ({
    method: "post",
    url: "drive/getDrivers",
    data
  })
}

//发送短信验证码
export function driveSendCodes(data) {
  return http.request ({
    method: "post",
    url: "drive/sendCode",
    data
  })
}

//数据同步信息校验
export function driveSyncData(data) {
  return http.request ({
    method: "post",
    url: "drive/syncData",
    data
  })
}

//数据同步
export function synchronousOperation(data) {
  return http.request ({
    method: "post",
    url: "synchronous/operation",
    data
  })
}

// 编辑
export function getAttrValueByDevCode2(data) {
  return http.request ({
    method: "post",
    url: "device/getAttrValueByDevCode2",
    data
  })
}
// 分配系统
export function getAttrValueByDevCode1(data) {
  return http.request ({
    method: "post",
    url: "device/getAttrValueByDevCode1",
    data
  })
}

//获取告警数据统计
export function getAlarmListAndNum(data) {
  return http.request ({
    method: "post",
    url: "alarm/getAlarmListAndNum",
    data
  })
}
